import React, { useEffect } from 'react';
import useLoadingContext
  from "@jetslash/market-frontend-shared-core/src/contexts/LoadingContextProvider/useLoadingContext";

import { goToUrl } from '@/utility/urlHelpers';
import ComponentLink from '@/components/navigation/ComponentLink';
import DesignText from '@/components/typography/DesignText';
import Header from '@/components/typography/Header';
import PageSeo from '@/components/seo/PageSeo';
import useCurrentUser from '@jetslash/market-frontend-shared-core/src/hooks/useCurrentUser';
import { useRouter } from 'next/router';
import useUserReturnTo from '@/utility/session/cookies/useUserReturnTo';
import useRedirectMsg from '@/hooks/useRedirectMsg';
import DisplayFlashMessages from '../layout/DisplayFlashMessages';
import Icon from '../Icon';
import Card from '../design/Card';
import Radio from '../forms/fields/Radio';
import SignInForm from '../forms/SignInForm';
import { Row, Col, Page } from '../layout';


const SignInPage = () => {
  const { currentUserIsAuthenticated } = useCurrentUser();
  const { loading } = useLoadingContext();
  const router = useRouter();
  const { getUserReturnTo } = useUserReturnTo();
  useRedirectMsg();

  useEffect(() => {
    if (currentUserIsAuthenticated) {
      router.push('/');
    }
  }, []);

  const onSignInSuccess = () => {
    const storedReturnPath = getUserReturnTo();
    if (storedReturnPath) {
      goToUrl(storedReturnPath);
    } else {
      goToUrl('/');
    }
  };

  return (
    <Page>
      <PageSeo title="Log In" />
      <Row style={{ marginTop: 60 }}>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 22, offset: 1 }}
          md={{ span: 20, offset: 2 }}
          lg={{ span: 12, offset: 6 }}
        >
          <Card
            title={
              <div style={{ textAlign: 'center' }}>
                <span>
                  <Icon name="user" />
                </span>
                <DesignText size="title">&nbsp;&nbsp;&nbsp;Log In</DesignText>
              </div>
            }
            loading={loading}
            style={{ minWidth: 353 }}
          >
            <Row>
              <Col span={24}>
                <div
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginBottom: 10,
                  }}
                >
                  <DisplayFlashMessages />
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <div style={{ marginLeft: 10, marginRight: 10, marginBottom: 10 }}>
                  <Radio.Group style={{ width: '100%' }} value="log_in_selected">
                    <Radio.Button
                      style={{ width: '50%', textAlign: 'center' }}
                      value="log_in_selected"
                      onClick={() => {}}
                    >
                      <Header
                        level={1}
                        style={{
                          fontSize: 14,
                          display: 'inline',
                          lineHeight: 1,
                        }}
                        strong
                        color="primary"
                      >
                        Log In
                      </Header>
                    </Radio.Button>
                    <ComponentLink href="/users/sign-up" shallow>
                      <Radio.Button style={{ width: '50%', textAlign: 'center' }} value="sign_up_selected">
                        <DesignText strong color="primary">
                          Sign Up
                        </DesignText>
                      </Radio.Button>
                    </ComponentLink>
                  </Radio.Group>
                </div>
              </Col>
            </Row>
            <SignInForm onSignInSuccess={onSignInSuccess} />
            <Row>
              <Col span={24} textCenter style={{ paddingTop: 10 }}>
                <ComponentLink href="/users/reset-password">Reset your password</ComponentLink>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Page>
  );
};

export default SignInPage;
